<template>
  <div>
    <v-row>
      <v-col>
        <div class="text-h6 mt-3 mb-4">Transférer cette inscription</div>
        <PendingTransfertInscription v-if="inscription.id" :id_inscription="inscription.id" :admin="true">
        </PendingTransfertInscription>
        <p>
          Vous vous apprêtez à transférer l'inscription de <b>{{ inscription.nom }} {{ inscription.prenom }}</b> au
          parcours <b v-if="inscription.course && inscription.course.nom">{{ inscription.course.nom }}</b>.
        </p>

        <p>Aucun mouvement financier ne sera effectué sur la plateforme. Le béneficiaire pourra béneficier de
          l'inscription gratuitement. L'inscription et les options* seront transférés. Ce transfert est irréversible.
        </p>
        <p>*Si le participant est inscrit à un autre parcours, ses options seront conservées.</p>
        <v-row>
          <v-col md="6">
            <FormTransfertInscriptionRecipient @onSuccess="send_transfert_request" :admin="true">
            </FormTransfertInscriptionRecipient>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Inscription from "@/classes/Fiche_Coureur/Inscription.class";
import FormTransfertInscriptionRecipient from "@/components/FicheCoureur/TransfertInscription/FormTransfertInscriptionRecipient.vue";
import PendingTransfertInscription from "@/components/FicheCoureur/TransfertInscription/PendingTransfertInscription.vue";
export default {
  components: {
    PendingTransfertInscription,
    FormTransfertInscriptionRecipient,
  },
  props: ["item"],
  data() {
    return {
      inscription: {},
    };
  },
  computed : {
    ...mapStores(useMainStore),
  },
  methods: {
    async send_transfert_request(recipient) {
      const origin = this.inscription.champs.mail ? this.inscription.champs.mail.value : "";
      let request = await this.inscription.send_admin_transfert_request(origin, recipient);

      if (request) {
        window.location.reload();
      }
    },
  },
  async created() {
    this.inscription = new Inscription(this.mainStore.module.id);
    this.inscription.id = this.item.id;
    let request = await this.inscription.get_admin();
    if (!request) {
      this.$router.push({ name: "FicheCoureur" });
    }
  },
};
</script>

<style lang="scss" scoped></style>